import { activityHistoryCollectionsSlice } from "../../slice";

export const { addErrorHistoryItem, removeErrorHistoryItem } =
  activityHistoryCollectionsSlice.actions;
